<ul>
    @for (item of items(); track item) {
        <li>{{ item }}</li>
    }
</ul>
